import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Storage } from 'aws-amplify';

import SelectOption from './SelectOption/SelectOption';
import SomeCollaborators from './SomeCollaborators/SomeCollaborators';
import { ReactComponent as XIcon } from '../../assets/icons/XIcon.svg';
import Context from '../../store/context';
import { paths } from '../../routes';
import AsyncLoad from '../AsyncLoad/AsyncLoad';
import apiMethods from '../../apis';
import useFetch from '../../services/hooks/http/useFetch';

import utils from '../../services/utils';
import { useSelector } from 'react-redux';

import classes from './OptionAddCollaborator.module.scss';

const stepsAyncLoad = [{ stepTitle: 'Subiendo archivo' }, { stepTitle: 'Creando colaboradores' }];

const initValues = {
  fileUpload: null,
  errorMessageAsyncLoad: null,
  currentStep: 0,
  filesStates: [],
  currentStepAsyncLoad: 0,
  isAsyncLoad: false
};

const OptionAddCollaborator = ({ refetch }) => {
  const {
    // toast: { showSuccess },
    modal: { showError },
    collaborator: { hideAddCollaborator, visible, isCloseVisible }
  } = useContext(Context);

  const { businessId } = useSelector(state => state.userData);

  const [fileUpload, setFileUpload] = useState(initValues.fileUpload);

  const [errorMessageAsyncLoad, setErrorMessageAsyncLoad] = useState(initValues.errorMessageAsyncLoad);

  const [currentStep, setCurrentStep] = useState(initValues.currentStep);

  const [filesStates, setFilesStates] = useState(initValues.filesStates);

  const [currentStepAsyncLoad, setCurrentStepAsyncLoad] = useState(initValues.currentStepAsyncLoad);

  const [isAsyncLoad, setAsyncLoad] = useState(initValues.isAsyncLoad);

  const {
    isSuccess: createSuccess,
    sendRequest: createCollaboratorsByFile,
    isError: createError,
    data: createCollaboratorData,
    errorMessage
  } = useFetch(apiMethods.createCollaboratorsByFile);

  useEffect(() => {
    const getStatusCreateCollaborators = async () => {
      await utils.promiseLoop(
        async () => {
          const result = await apiMethods.getCollaboratorsBatchCreationById[1](createCollaboratorData.collaboratorsbatchId);
          return result?.body;
        },
        collaborator => {
          const isProcessFinished = collaborator.status === 'FINISHED';
          setFilesStates(files => {
            const auxFiles = [...files];
            auxFiles[0] = { ...auxFiles[0], state: collaborator.status };
            return auxFiles;
          });
          collaborator.state === 'ERROR' && setErrorMessageAsyncLoad(collaborator.stateMessage);
          isProcessFinished &&
            setTimeout(() => {
              setFileUpload(initValues.fileUpload);
              setErrorMessageAsyncLoad(initValues.errorMessageAsyncLoad);
              setCurrentStep(initValues.currentStep);
              setFilesStates(initValues.filesStates);
              setCurrentStepAsyncLoad(initValues.currentStepAsyncLoad);
              setAsyncLoad(initValues.isAsyncLoad);
            }, 10000);
          return { isProcessFinished };
        }
      );
    };
    if (createSuccess) {
      getStatusCreateCollaborators();
    } else if (createError) {
      setErrorMessageAsyncLoad('Error al crear los colaboradores');
    }
  }, [createCollaboratorData, createError, createSuccess, errorMessage, showError]);

  const navigate = useNavigate();
  const optionSelected = option => {
    if (option === 'one') {
      navigate(paths.addCollaborators);
      hideAddCollaborator();
    } else {
      setCurrentStep(1);
    }
  };

  const [showModal, setShowModal] = useState(visible);

  useEffect(() => {
    setShowModal(visible);
  }, [visible]);

  const containerClasses = [classes.container];
  if (visible) {
    containerClasses.push(classes.visible);
  }

  const modalClasses = [classes.modal];
  if (showModal) {
    modalClasses.push(classes['modal-visible']);
  }

  const closeHandler = () => {
    setFileUpload(initValues.fileUpload);
    setCurrentStep(initValues.currentStep);
    setShowModal(false);
    hideAddCollaborator();
    setTimeout(() => hideAddCollaborator(), 250);
  };

  const uploadFiles = async (path, format) => {
    try {
      hideAddCollaborator();
      setFilesStates([
        {
          fileName: fileUpload.name,
          format,
          state: 'PROCESSING'
        }
      ]);
      setAsyncLoad(true);
      await Storage.put(path, fileUpload);
      setCurrentStepAsyncLoad(1);
      createCollaboratorsByFile(businessId, path);
    } catch (error) {
      setFilesStates([
        {
          fileName: fileUpload.name,
          format,
          state: 'ERROR'
        }
      ]);
      //showError({ title: 'Subiendo archivos', description: 'Error al subir los archivos S3' });
      setErrorMessageAsyncLoad('Error al subir los archivos a S3');
    }
  };

  const backButtonHandler = () => {
    setFileUpload(initValues.fileUpload);
    setCurrentStep(initValues.currentStep);
  };

  return !isAsyncLoad ? (
    <div className={containerClasses.join(' ')}>
      <div className={modalClasses.join(' ')}>
        {isCloseVisible && (
          <div className={`pointer ${classes.close}`} onClick={closeHandler}>
            <span>Cerrar</span>
            <XIcon className={classes.icon} />
          </div>
        )}

        <>
          {currentStep === 0 && <SelectOption optionSelected={optionSelected}  type={'collaborator'} />}
          {currentStep === 1 && (
            <SomeCollaborators
              backButtonHandler={backButtonHandler}
              fileUpload={fileUpload}
              setFileUpload={setFileUpload}
              setCurrentStep={setCurrentStep}
              optionSelected={optionSelected}
              uploadFiles={uploadFiles}
              refetch={refetch}
            />
          )}
        </>
      </div>
    </div>
  ) : (
    <div className={classes.async}>
      <AsyncLoad
        globalState={!!errorMessageAsyncLoad}
        errorMessage={errorMessageAsyncLoad}
        steps={stepsAyncLoad}
        files={filesStates}
        currentStep={currentStepAsyncLoad}
      />
    </div>
  );
};

export default OptionAddCollaborator;
